import {
    ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges,
    ViewChild
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SnackService} from '../../services/snack.service';
import {PaymentType} from '../../model/Entities/PaymentType';
import {ProductService} from '../../services/product.service';
import {Contract} from '../../model/Entities/Contract';
import {Customer} from '../../model/Entities/Customer';
import {Observable} from 'rxjs/Observable';
import {Filter} from '../../model/Helpers/Filter';
import {CustomerService} from '../../services/customer.service';
import {MatSort, MatTableDataSource} from '@angular/material';
import {ContractItem} from '../../model/Entities/ContractItem';
import {ContractService} from '../../services/contract.service';
import {FormControl, Validators} from '@angular/forms';
import {CustomerContactPersonService} from '../../services/customer-contact-person.service';
import {CustomerContactPerson} from '../../model/Entities/CustomerContactPerson';
import {numberValidator} from '../../validators/number.validator';
import {Product} from '../../model/Entities/Product';
import {ProductType} from '../../model/Entities/ProductType';
import {ProductContent} from '../../model/Entities/ProductContent';
import {ContractState} from '../../model/Entities/ContractState';
import {ContractItemService} from '../../services/contract-item.service';
import {VatRateService} from '../../services/vat-rate.service';
import {ContractItemTransferService} from '../../services/contract-item-transfer.service';
import {ContractItemTransfer} from '../../model/Entities/ContractItemTransfer';
import {DialogService} from '../../services/dialog.service';
import {ContractItemsTransferDialogComponent} from '../ContractItemsTransferDialogComponent/contract-items-transfer.dialog.component';
import {SingleContractItemTransferDialogComponent} from '../SingleContractItemTransferDialogComponent/single-contract-item-transfer.dialog.component';
import {ProductContractItem} from '../../model/Entities/ProductContractItem';
import {ContractGroupItemLossDialogComponent} from '../ContractGroupItemLossDialogComponent/contract-group-item-loss.dialog.component';

@Component({
    selector: "contract-items-transfer-list",
    templateUrl: "./contract-items-transfer-list.component.html",
    styleUrls: ["./contract-items-transfer-list.component.scss"],
})
export class ContractItemsTransferListComponent implements OnInit, OnChanges {
    @Input() contract: Contract;
    @Input() direction: any;
    @Input() isGlobalLoading: boolean = false;
    @Output() isGlobalLoadingChange = new EventEmitter<boolean>();

    public contractItems: ContractItem[] = [];

    displayedColumns = [
        "itemName",
        "orderedCount",
        "dispatchedCount",
        "returnedCount",
        "actions",
    ];
    itemsDataSource: MatTableDataSource<ContractItem> =
        new MatTableDataSource<ContractItem>([]);

    constructor(
        private contractItemService: ContractItemService,
        private contractItemTransferService: ContractItemTransferService,
        private dialogService: DialogService,
        private snackService: SnackService
    ) {}

    ngOnInit(): void {
        this.reloadItemsDS();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (
            changes.contract &&
            changes.contract.previousValue !== changes.contract.currentValue &&
            this.contract.id
        ) {
            this.loadContractItems(this.contract.id);
        }
        this.reloadItemsDS();
    }

    transferAll(): void {
        this.isGlobalLoadingChange.emit(true);
        this.isGlobalLoading = true;

        const itemsToTransfer = this.contractItems.filter((i: ContractItem) => {
            return !i.isDeployment() && !i.isDelivery() && !i.isText();
        });

        if (itemsToTransfer.length === 0) {
            this.isGlobalLoading = false;
            this.isGlobalLoadingChange.emit(false);
            return;
        }

        let completedTransfers = 0;
        const totalTransfers = itemsToTransfer.length;

        itemsToTransfer.forEach((i: ContractItem) => {
            this.makeTransfer(i as ProductContractItem, null, () => {
                completedTransfers++;
                if (completedTransfers >= totalTransfers) {
                    this.isGlobalLoading = false;
                    this.isGlobalLoadingChange.emit(false);
                }
            });
        });
    }

    makeTransfer(
        ci: ProductContractItem & { loading?: boolean },
        count: number | null = null,
        onComplete?: () => void
    ): void {
        ci.loading = true;
        const transfer: ContractItemTransfer = new ContractItemTransfer();
        transfer.contractItemId = ci.id;
        if (count === null && this.direction === ContractItemTransfer.OUT) {
            transfer.count = ci.lentCount - ci.dispatched;
        } else if (
            count === null &&
            this.direction === ContractItemTransfer.IN
        ) {
            transfer.count = ci.dispatched - ci.returned;
        } else {
            transfer.count = count;
        }

        if (transfer.count === 0) {
            if (onComplete) {
                onComplete();
            }
            return;
        }

        transfer.direction = this.direction;

        this.contractItemTransferService.save(transfer).subscribe(
            (result: ContractItemTransfer) => {
                if (this.direction === ContractItemTransfer.IN) {
                    ci.returned += result.count;
                } else {
                    ci.dispatched += result.count;
                }
                this.reloadItemsDS();
                ci.loading = false;
                if (onComplete) {
                    onComplete();
                }
            },
            (error) => {
                ci.loading = false;
                console.log("chyba pri vyskladneni produktu", error);
                if (error.status === 400) {
                    this.snackService.showWarn(
                        `Nepodařilo se vyskladnit produkty. Byla překročena skladová zásoba.`
                    );
                } else {
                    this.snackService.showWarn(
                        `Nepodařilo se vyskladnit produkty.`
                    );
                }
                console.error(error);
                if (onComplete) {
                    onComplete();
                }
            }
        );
    }

    openSingleTransferDialog(ci: ProductContractItem): void {
        this.dialogService
            .showDialog(
                SingleContractItemTransferDialogComponent,
                {
                    contractItem: ci,
                    direction: this.direction,
                },
                400
            )
            .afterClosed()
            .subscribe((result: number) => {
                if (result) {
                    this.makeTransfer(ci, result, null);
                }
            });
    }

    openGroupItemLossDialog(ci: ProductContractItem): void {
        this.dialogService
            .showDialog(
                ContractGroupItemLossDialogComponent,
                {
                    contractItem: ci,
                },
                600
            )
            .afterClosed()
            .subscribe();
    }

    reloadItemsDS(): void {
        this.itemsDataSource = new MatTableDataSource<ContractItem>(
            this.contractItems.filter((item) => {
                return (
                    !item.isDeployment() &&
                    !item.isDelivery() &&
                    !item.isText() &&
                    !item.isLoss
                );
            })
        );
        this.itemsDataSource.sort = new MatSort();
    }

    private loadContractItems(contractId): void {
        this.contractItemService
            .getSimpleList([new Filter("contract_id", contractId)], {
                expand: "dispatched,returned",
            })
            .subscribe((items: ContractItem[]) => {
                this.contractItems = items;
                this.reloadItemsDS();
            });
    }
}



// WEBPACK FOOTER //
// /app/src/ContractsModule/ContractItemsTransferListComponent/contract-items-transfer-list.component.ts